import { useSeasonalChartSeries } from '@/features/charts';
import type { ChartDataRange } from '@/features/charts/types/chartData';
import BasicChartBlock from '@/features/markets/components/Chart/BasicChartBlock';
import useInViewport from '@/shared/hooks/useInViewport';
import type { TemplateChartSeries } from '@/shared/types/charts';

type SeasonalChartBlockType = {
  layout?: { fullWidth?: boolean; height?: number };
  templateChartSeries?: TemplateChartSeries[];
  chartDataRange: ChartDataRange;
};
const SeasonalChartBlock = ({
  layout,
  templateChartSeries,
  chartDataRange
}: SeasonalChartBlockType) => {
  const [containerRef, isInViewport] = useInViewport();
  const { loading, error, chartSeries } = useSeasonalChartSeries(
    templateChartSeries,
    chartDataRange,
    isInViewport
  );

  return (
    <BasicChartBlock
      chartSeries={chartSeries}
      chartType='seasonal'
      containerRef={containerRef}
      error={error}
      label='Seasonal prices'
      layout={layout}
      loading={loading}
    />
  );
};

export default SeasonalChartBlock;
